module.exports = __webpack_public_path__ + "img/12157760000196.f0413396.png";